import React, { useState } from 'react';
import {
  Button,
  TextField,
  FormLabel,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Stack,
  Box,
  Alert,
} from '@mui/material';
import useAdminRequest from '../../../requests/AdminRequest';

const AdminDebugPDF = ({ errorHandler }) => {
  const typeOptions = [
    { value: 'usage', label: 'Cost Centre Usage' },
    { value: 'invoice', label: 'Invoice' },
    { value: 'customer', label: 'Customer' },
  ];

  const [type, setType] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [customerId, setCustomerId] = useState(1);
  const { getPdf } = useAdminRequest();

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    setError(null);
    setLoading(true);

    const response = await getPdf(type, email, customerId, errorHandler);
    setLoading(false);

    if (!response) {
      setError(response.statusText);
      return;
    }

    if (email) {
      setSuccess(true);
    } else {
      const url = window.URL.createObjectURL(response);
      window.open(url, '_blank');

      setTimeout(() => window.URL.revokeObjectURL(url), 10000);
    }
  };

  const typeChange = (event) => {
    setType(event.target.value);
  };

  const emailChange = (event) => {
    setEmail(event.target.value);
  };

  const customerIdChange = (event) => {
    setCustomerId(event.target.value);
  };

  return (
    <>
      <Typography variant="h2">PDF</Typography>

      <form onSubmit={handleSubmit}>
        <Stack gap={2} sx={{ maxWidth: 800 }}>
          <Stack sx={{ flexDirection: { md: 'row', gap: 8 } }}>
            <FormControl required fullWidth sx={{ maxWidth: 200 }}>
              <FormLabel id="type-label">Type</FormLabel>
              <Select
                labelId="type-label"
                id="type"
                name="type"
                value={type}
                size="small"
                displayEmpty
                onChange={typeChange}
              >
                <MenuItem value="">Select...</MenuItem>
                {typeOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl required fullWidth>
              <FormLabel>Customer ID</FormLabel>
              <TextField
                type="text"
                name="customerId"
                value={customerId}
                onChange={customerIdChange}
                size="small"
                required
              />
            </FormControl>

            <FormControl fullWidth>
              <FormLabel>Email</FormLabel>
              <TextField
                type="email"
                name="email"
                value={email}
                placeholder="Optional"
                size="small"
                onChange={emailChange}
              />
            </FormControl>
          </Stack>

          <Box>
            <Button
              type="submit"
              disabled={loading}
              variant="contained"
              color="secondary"
            >
              Retrieve
            </Button>
          </Box>

          {success && <Alert severity="success">Email Sent</Alert>}
          {error && <Alert severity="error">{error}</Alert>}
        </Stack>
      </form>
    </>
  );
};

export default AdminDebugPDF;
